import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { dashboardLoader } from './dashboard-loader';

export const dashboardRoutes: RouteObject = {
  loader: dashboardLoader,
  children: [
    {
      path: '/',
      lazy: lazyComponent(() => import('@pages/client/dashboard'), 'DashboardPage'),
    },
  ],
};
